import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Dialog,
  Typography,
} from '@material-ui/core'
import { useStyles } from '../styles'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Stack from '@mui/material/Stack'
import moment from 'moment'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useGetIdentity, useRefresh } from 'react-admin'
import Api from '../../../Apis/api.service'
import { useEffect, useState } from 'react'
import PreviewFile from '../../../common/PreviewFile/PreviewFile'
import { Button } from '@mui/material'

const PlannedTasks = ({ tasks, refresh, generalAssemblyId, condoId }) => {
  const { identity } = useGetIdentity()
  const [canForceConvocation, setCanForceConvocation] = useState(false)
  const getCanForceConvocation = async () => {
    const res = await Api.ags.getCanForceConvocation(condoId, generalAssemblyId)
    setCanForceConvocation(res.canForceConvocation)
  }

  useEffect(() => {
    getCanForceConvocation(generalAssemblyId)
  }, [generalAssemblyId])

  return tasks.map((task) => {
    let planTime = moment(task.date)
    var duration = moment.duration(moment().diff(planTime))
    let time = duration.humanize({ precision: 2 })

    let runOrCancelConvocationTask = async (action) => {
      await Api.ags.runOrCancelConvocationTask(
        condoId,
        task.task_name,
        task.task_id,
        generalAssemblyId,
        action
      )
      refresh()
    }
    let isAdmin = identity?.email === 'kevin_s@hello-syndic.fr'
    return (
      <Alert
        variant="outlined"
        severity="success"
        icon={false}
        action={
          <>
            {canForceConvocation && (
              <Button
                color="primary"
                variant="contained"
                size="small"
                onClick={() => {
                  runOrCancelConvocationTask('runnow')
                }}
                style={{ marginRight: '10px', paddingLeft: '20px' }}
              >
                Lancer immediatement
              </Button>
            )}
            {isAdmin && (
              <Button
                variant="contained"
                color="error"
                size="small"
                onClick={() => {
                  runOrCancelConvocationTask('cancel')
                }}
                style={{ marginRight: '10px', paddingLeft: '20px' }}
              >
                Annuler
              </Button>
            )}
          </>
        }
      >
        {task.action} dans {time}
      </Alert>
    )
  })
}
const Informations = ({ informations, refresh, ag_id }) => {
  const classes = useStyles()
  const [file, setFile] = useState('')
  const [openPreview, setOpenPreview] = useState(false)
  const [loadingFile, setLoadingFile] = useState(false)
  const getConvocationPreview = async () => {
    setLoadingFile(true)
    const res = await Api.ags.getConvocationPreview(ag_id)
    if (res.status == 200) {
      setFile(res.data.content)
      setOpenPreview(true)
    }
    setLoadingFile(false)
  }
  const errorBlock = informations?.error ? (
    <div>
      <Accordion
        style={{ backgroundColor: 'rgb(211, 47, 47)', color: 'white' }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ fill: 'white' }} />}
        >
          <Typography>Une erreur est survenue</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            {informations.error
              .replace('Error:', '')
              .split('at ')
              .map((stack) => (
                <>
                  <span>{stack}</span>
                  <br />
                </>
              ))}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  ) : null

  if (
    !informations?.plannedTriggerDate &&
    !informations?.convocation_triggered_at
  ) {
    return (
      <>
        {errorBlock}
        <Alert severity="info">
          L'AG a eu lieu, il n'est plus possible d'envoyer les convocations
        </Alert>
      </>
    )
  }
  if (
    informations?.convocation_triggered_at ||
    informations?.planned?.length > 0
  ) {
    return (
      <>
        {errorBlock}
        {informations?.convocation_triggered_at && (
          <Alert
            severity="success"
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'row',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
              }}
            >
              <div style={{ marginRight: '10px' }}>
                Déclenché le{' '}
                {moment(informations.convocation_triggered_at).format('LL')} par{' '}
                {informations?.convocation_triggered_by}
                {informations?.subscription_url && (
                  <span style={{ fontWeight: 'bold' }}>
                    {' '}
                    - ID Athome de suivi:{' '}
                    {informations.subscription_url.split('/').pop()}
                  </span>
                )}
              </div>

              {informations?.subscription_url && (
                <Button
                  component="a"
                  href={informations.subscription_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  color="primary"
                  variant="contained"
                  size="large"
                >
                  Suivre les envois pour la commande
                </Button>
              )}
            </div>
          </Alert>
        )}
        <PlannedTasks
          tasks={informations.planned}
          refresh={refresh}
          generalAssemblyId={informations.id}
          condoId={informations.condo_id}
        />
      </>
    )
  } else {
    return (
      <>
        <Alert severity="info">
          Vous disposez d'un outil unique et intégré qui permet d'envoyer les
          convocations aux Assemblées Générales en LRAR ou LRE (recommandé
          digital) en fonction du consentement du contact qui est convoqué.
          <br />
          Vous pouvez activer un envoi automatique ou déclencher manuellement
          l'envoi.
          <br />
          <ul>
            <li>
              En cas d'envoi automatique activé : les convocations sont envoyées
              1 mois avant l'AG (J-31)
            </li>
            <li>
              En cas de déclenchement manuel : les convocations LRAR ou LRE sont
              envoyées <b>lors du clic sur "Envoyer les convocations"</b>.
              Veuillez respecter un délai minimum de 28 jours avant la date
              d'Assemblée Générale pour envoyer vos convocations.
            </li>
          </ul>
        </Alert>
        <Alert severity="warning" className={classes.alertWarning}>
          <p style={{ marginRight: '10px' }}>
            Attention, la convocation est générée par Hello App (cela peut
            prendre jusqu'à 30 secondes) -{' '}
            <strong>
              vérifiez le contenu sur Hello App avant de lancer le processus de
              convocation ou d'activer l'envoi automatique.
            </strong>
          </p>
          <Button
            className={classes.button}
            disabled={loadingFile}
            onClick={() => {
              getConvocationPreview()
            }}
          >
            {loadingFile ? 'Chargement...' : 'Prévisualiser la convocation'}
          </Button>
        </Alert>
        <PreviewFile
          base64={file}
          open={openPreview}
          onClose={() => {
            setOpenPreview(!openPreview)
            setFile('')
          }}
        />
      </>
    )
  }
}

const ConvocationsHeader = ({ informations, refresh, id }) => {
  const classes = useStyles()
  return (
    <Stack sx={{ width: '100%' }} spacing={2}>
      <Informations informations={informations} refresh={refresh} ag_id={id} />
    </Stack>
  )
}

export default ConvocationsHeader
